import { formatNumber, formatPricePerTonne } from 'ui';

export const formatMatchPrice = ({
  pricePerTonne,
  currency,
  priceAsIndexPercentage,
  priceIndex,
}: {
  pricePerTonne?: string;
  currency?: string;
  priceAsIndexPercentage?: string;
  priceIndex?: string;
}): string | undefined => {
  if (!pricePerTonne && !priceAsIndexPercentage) {
    return undefined;
  }

  if (priceAsIndexPercentage && priceIndex) {
    return `${formatNumber(priceAsIndexPercentage, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: 'percent',
    })} of ${priceIndex}`;
  }

  if (pricePerTonne && currency) {
    return formatPricePerTonne(pricePerTonne, currency);
  }
};
